import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, LoginImpersonateContainerComponent, UnauthGuard } from '@motivforce/mx-library-angular';

import { LoginRedirectContainerComponent } from './components/login-redirect-container/login-redirect-container.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    data: {
      pageTitle: 'Login', // No translation service available at this point
    },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'set-password',
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [UnauthGuard],
  },
  {
    path: 'redirect',
    component: LoginRedirectContainerComponent,
    canActivate: [],
    data: {
      hideHeaderFooter: true,
    },
  },
  {
    path: 'impersonate',
    component: LoginImpersonateContainerComponent,
    canActivate: [AuthGuard],
    data: {
      hideHeaderFooter: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
